import {ROUTES} from '@/router/routes'
import {ProductsMap} from '@/stores/auth/constants/products-map'

export const routesProductsMap = {
    [ROUTES.home]: [],
    [ROUTES.overview]: [],
    [ROUTES.onboarding.base]: [],
    [ROUTES.paymentLinks]: [],
    [ROUTES.onlinePayments]: [],
    [ROUTES.posPayments]: [],
    [ROUTES.posAmexPayments]: [ProductsMap.amex],
    [ROUTES.settlements.perSettlementDate]: [],
    [ROUTES.settlements.perTransactionDate]: [],
    [ROUTES.dcc]: [],
    [ROUTES.zashEpos]: [],
    [ROUTES.digitalReceipts]: [],
    [ROUTES.virtualTerminal]: [],
    [ROUTES.reports]: [],
    [ROUTES.exports]: [],
    [ROUTES.profile]: [],
    [ROUTES.settings.developers]: [],
    [ROUTES.settings.checkout]: [],
    [ROUTES.settings.tariffs]: [],
    [ROUTES.settings.companyProfile]: [],
    [ROUTES.businessAccount.accountInfo]: [],
    [ROUTES.businessAccount.cardsManagement]: [],
    [ROUTES.settings.paymentMethods]: [],
    [ROUTES.settings.paymentMethodDetails]: [],
    [ROUTES.billing.invoices]: [],
    [ROUTES.noPermissions]: []
}
